// Builds the single `Kommunicate.customizeWidgetCss` string: theme + optional
// :root tokens (see TOKEN_MAP) and the bundled chatbot avatar URL.
import chatbotAvatarUrl from './assets/Chatbot.svg'
import themeCss from './theme.css?inline'

const TOKEN_MAP = {
  primaryColor: '--fintepla-purple',
  primaryColorHover: '--fintepla-purple-hover',
  focusRingColor: '--fintepla-focus-ring',
  headingFontFamily: '--fintepla-font-heading',
  bodyFontFamily: '--fintepla-font-body',
}

function buildTokenBlock(config) {
  const decls = Object.entries(TOKEN_MAP)
    .map(([configKey, cssVar]) => [cssVar, config?.[configKey]])
    .filter(([, value]) => typeof value === 'string' && value.length > 0)
    .map(([cssVar, value]) => `  ${cssVar}: ${value} !important;`)

  // The chatbot avatar URL is resolved by Vite at import time:
  //   dev:  absolute localhost URL  e.g. `http://localhost:5173/src/assets/Chatbot.svg`
  //   prod: URL-encoded inline data URI (`data:image/svg+xml,%3c?xml…`)
  //
  // IMPORTANT: use double-quote delimiters for the CSS url() value.
  // Vite's SVG optimiser converts XML attribute quotes from double → single
  // (e.g. version="1.0" → version='1.0'), and encodeURIComponent does NOT
  // encode `'`.  A url('…') with literal single-quotes inside would have its
  // string terminated at the first `'`, yielding a broken/truncated URL.
  // encodeURIComponent DOES encode `"` as `%22`, so double-quote delimiters
  // are always safe regardless of the URI contents.
  decls.push(`  --fintepla-chatbot-avatar: url("${chatbotAvatarUrl}") !important;`)

  // The token block is emitted first so it cascades into the base rules in
  // theme.css. `!important` is used on the custom properties so they beat
  // any value Kommunicate may set on :root.
  return `:root {\n${decls.join('\n')}\n}\n`
}

/**
 * Build the widget CSS override string.
 *
 * @param {object} [config]  Optional branding overrides. See TOKEN_MAP.
 * @returns {string}         CSS string suitable for `Kommunicate.customizeWidgetCss`.
 */
export function buildWidgetCss(config = {}) {
  return buildTokenBlock(config) + themeCss
}

